export const DeviceSize = {
  mobile: 768,
  tablet: 992,
  laptop: 1366,
  desktop: 1920
};